import { useMemo } from "react";
import { Icon } from "@iconify/react";
import { GetDateWithTime, handlePluralString } from "@markit/common.utils";
import { Spreadsheet, SpreadsheetImportStatus } from "@markit/common.types";
import { addAlpha, Colors } from "../../../utils/colors";
import { HorizontalDivider } from "../../Dividers/HorizontalDivider";
import LabelButton from "../../Buttons/LabelButton";

export const IMPORT_HISTORY_FLEX_SECTIONS = [2, 1, 1];

type ImportHistoryItemProps = {
  item: Spreadsheet;
};

const ImportHistoryItem = ({ item }: ImportHistoryItemProps) => {
  const statusItems = useMemo(() => {
    if (item.importStatus === SpreadsheetImportStatus.IN_PROGRESS) {
      return {
        icon: "mdi:dots-circle",
        color: Colors.BLACK,
        borderColor: Colors.ORANGE1,
        backgroundColor: addAlpha(Colors.ORANGE1, 0.1),
        text: "In Progress",
      };
    } else if (item.importStatus === SpreadsheetImportStatus.FAILED) {
      return {
        icon: "ion:close-circle",
        color: Colors.RED3,
        borderColor: Colors.RED3,
        backgroundColor: addAlpha(Colors.RED3, 0.1),
        text: "Failed",
      };
    }
    return {
      icon: "ion:checkmark-circle",
      color: Colors.GREEN2,
      borderColor: Colors.GREEN2,
      backgroundColor: addAlpha(Colors.GREEN2, 0.1),
      text: "Completed",
    };
  }, [item.importStatus]);

  return (
    <div>
      <div className="AlignedRow" style={{ paddingBlock: 10 }}>
        <div
          className="ColumnNormal"
          style={{ gap: 4, flex: IMPORT_HISTORY_FLEX_SECTIONS[0] }}
        >
          <span className="bodyMedium TextOverflowEllipsis">
            {item.fileName}
          </span>
          <span className="smallBodySubtext">
            {GetDateWithTime(item.createdAt, true)}
          </span>
        </div>
        <div
          className="ColumnNormal"
          style={{ gap: 4, flex: IMPORT_HISTORY_FLEX_SECTIONS[1] }}
        >
          <span className="bodyMedium">
            {item.totalValidUsers} New{" "}
            {handlePluralString("Contact", item.totalValidUsers)}
          </span>
          <span className="smallBodySubtext">Imported</span>
        </div>
        <div
          className="AlignedRowSpaced"
          style={{ flex: IMPORT_HISTORY_FLEX_SECTIONS[2] }}
        >
          <LabelButton
            color={statusItems.color}
            backgroundColor={statusItems.backgroundColor}
            borderColor={statusItems.borderColor}
            text={statusItems.text}
            icon={
              <Icon
                icon={statusItems.icon}
                height={14}
                style={{ color: statusItems.color }}
              />
            }
          />
        </div>
      </div>
      <HorizontalDivider altMargin={14} />
    </div>
  );
};

export default ImportHistoryItem;
